import Component from "@glimmer/component"
import styles from "./body.module.css"

export default class ToggleCoursesBodyComponent extends Component {
  readonly styles = styles
}
